import { CosmeticCreate } from '@/components/config/CosmeticCreate';
import { GlyphAtlasEditor } from '@/components/config/GlyphAtlasEditor';
import styles from '../GradesPage.module.scss';

/** Section « Création » (groupe Grades) : créer un ornement / rank tag + lister ceux existants (par onglet). */
export function CosmeticsPage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Cosmetics</h1>
        <p className={styles.subtitle}>
          Créer un ornement (nametag) ou un rank tag, et voir ceux qui existent. Un cosmetic créé devient disponible dans l'onglet Apparence des grades.
        </p>
      </header>

      <section className={styles.detail}>
        <CosmeticCreate />
      </section>

      <section className={styles.detail}>
        <GlyphAtlasEditor page="F1" />
      </section>
    </div>
  );
}
